import { useQuery } from '@tanstack/react-query';

import { useCapability } from '../../../hooks/use-capability';
import { api } from '../../../lib/api-client';

import type { ProactiveTemplate } from '../../proactive/types';

/**
 * Item 27 — templates aprovados do tenant para o seletor do Composer.
 *
 * Reusa `GET /v1/proactive-conversations/templates` SEM categoria (todos os
 * aprovados) — gate `initiate-proactive-conversation`, que o atendente TEM
 * (`message-template-read` é GESTOR_EXTRA). Fetch gateado: cap + chamador
 * passa `enabled` (modal aberto) — não dispara GET que renderia 403.
 */
export function useApprovedTemplates(enabled: boolean): {
  data: ProactiveTemplate[] | undefined;
  isLoading: boolean;
  isError: boolean;
} {
  const canList = useCapability('initiate-proactive-conversation');
  const query = useQuery({
    queryKey: ['approved-templates'],
    queryFn: () => api.listProactiveTemplates(undefined),
    enabled: enabled && canList,
    staleTime: 30 * 1000,
  });
  return { data: query.data, isLoading: query.isLoading, isError: query.isError };
}
